import React from 'react';
import { Alert, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';
import { useCustomerCreditHold } from '../hooks/useCustomerCreditHold';

/**
 * Sticky amber banner shown on every authenticated page while the
 * customer is on credit hold. Non-dismissable by design — it clears
 * automatically when the next customer sync flips credit_hold back to
 * false, so any lingering banner is a real signal, not stale UI state.
 */
const CreditHoldRibbon: React.FC = () => {
  const { t } = useTranslation();
  const { creditHold, isLoading } = useCustomerCreditHold();

  if (isLoading || !creditHold) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 64,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        width: '100%',
      }}
    >
      <Alert
        severity="warning"
        icon={<WarningAmberIcon fontSize="inherit" />}
        sx={{
          borderRadius: 0,
          py: 1,
          px: { xs: 2, md: 3 },
          fontSize: { xs: '0.85rem', md: '0.95rem' },
          '& .MuiAlert-message': { width: '100%' },
        }}
      >
        {t('creditHold.ribbon')}
      </Alert>
    </Box>
  );
};

export default CreditHoldRibbon;
